import { render, staticRenderFns } from "./fandou.vue?vue&type=template&id=fb4ab042&scoped=true&"
import script from "./fandou.vue?vue&type=script&lang=js&"
export * from "./fandou.vue?vue&type=script&lang=js&"
import style0 from "./fandou.vue?vue&type=style&index=0&id=fb4ab042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4ab042",
  null
  
)

export default component.exports